import KumosearchError from "./KumosearchError";

export default class ObjectNotFound extends KumosearchError {}
